import type { LocationUIState } from '../../../../store/types/template';

export const APPLE_LOCATION_MESSAGE_MAX_CHARS = 250;

export function locationHasPlacedPin(
  loc: Pick<LocationUIState, 'latitude' | 'longitude'>
): boolean {
  return (
    loc.latitude != null &&
    loc.longitude != null &&
    loc.latitude !== 0 &&
    loc.longitude !== 0 &&
    !Number.isNaN(loc.latitude) &&
    !Number.isNaN(loc.longitude)
  );
}
